export function getHeaderTitle(selectedTab: any) {
  switch (selectedTab) {
    case "user-activity":
      return "User Activity";
    case "revenue":
      return "Financial Insights";
    case "tickets":
      return "Customer Support Ticket";
    default:
      return "Dashboard";
  }
}
